<template>
    <v-row>
        <v-col cols="12" sm="6" md="3">
            <v-card :color="getColor('cardCyan')">
                <v-card-text>
                    <p class="mb-0 stat-card">
                        <b>{{ userStats.workExperience }}</b>
                        <br />
                        <span class="text--secondary">{{
                            $t('dashboardView.workExperience')
                        }}</span>
                    </p>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3">
            <v-card :color="getColor('cardBlue')">
                <v-card-text>
                    <p class="mb-0 stat-card">
                        <b>{{ userStats.vacationsRemaining }}</b>
                        <br />
                        <span class="text--secondary">{{
                            $t('dashboardView.vacationsRemaining')
                        }}</span>
                    </p>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3">
            <v-card :color="getColor('cardIndigo')">
                <v-card-text>
                    <p class="mb-0 stat-card">
                        <b>{{ userStats.vacationsTaken }}</b>
                        <br />
                        <span class="text--secondary">{{
                            $t('dashboardView.vacationsTaken')
                        }}</span>
                    </p>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3">
            <v-card :color="getColor('cardPurple')">
                <v-card-text>
                    <p class="mb-0 stat-card">
                        <b>{{ userStats.vacationsPending }}</b>
                        <br />
                        <span class="text--secondary">{{
                            $t('dashboardView.vacationsPending')
                        }}</span>
                    </p>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'userStats',

    computed: {
        ...mapGetters({
            userStats: 'auth/getUsersStats'
        }),

        themeName() {
            return this.$vuetify.theme.dark ? 'dark' : 'light';
        }
    },

    async created() {
        await this.fetchUsersStats();
    },

    methods: {
        ...mapActions({
            fetchUsersStats: 'auth/fetchUsersStats'
        }),

        getColor(color) {
            return this.$vuetify.theme.themes[this.themeName][color];
        }
    }
};
</script>
